import { EdgeSection } from "@/components/site/EdgeSection";
import { edgeProfileFor } from "@/lib/edgeProfiles";

// Distinct edge profiles cut on these pieces, in the order they first appear.
export const usedEdgeProfiles = (pieces) => {
  const seen = new Map();
  for (const p of pieces || []) {
    for (const e of p.edges || []) {
      const prof = edgeProfileFor(e.profile);
      if (prof && !seen.has(prof.slug)) seen.set(prof.slug, { ...prof, label: e.profile });
    }
  }
  return [...seen.values()];
};

// Small cross-section drawings of every profile on a quote area, with the office name under each.
export const EdgeProfilesStrip = ({ pieces, testId, className = "" }) => {
  const list = usedEdgeProfiles(pieces);
  if (!list.length) return null;
  return (
    <div className={`flex flex-wrap gap-3 ${className}`} data-testid={testId}>
      {list.map((p) => (
        <figure key={p.slug} className="w-[132px]" data-testid={`${testId}-${p.slug}`}>
          <div className="border border-slate-200 bg-white">
            <EdgeSection profile={p} className="h-auto w-full" />
          </div>
          <figcaption className="mt-1 text-[11px] font-semibold leading-tight text-slate-700">
            {p.label}
          </figcaption>
        </figure>
      ))}
    </div>
  );
};
